import { useTranslation } from "react-i18next";
import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import Layout from 'Components/Layout';
import ProfileList from 'Components/Personal/ProfileList';
import { setAdminMode as setIsOpen } from 'store/slices/businessSlice';
import PageHeader from 'Components/PageHeader/PageHeader';
import './Personal.css';

function Main({
  profile,
  setIsOpen
}) {
  const {
    t
  } = useTranslation();
  const title = "Profile";
  const description = "This information is never shared with anyone until you put it in a Card.";
  return <Layout>
      <Helmet>
        <title>{t("Profile - HeresMyInfo.com")}</title>
      </Helmet>
      <PageHeader title={title} description={description} />
      <ProfileList profile={profile} setIsOpen={setIsOpen} />
    </Layout>;
}

const mapStateToProps = state => ({
  profile: state.auth.currentUser.profile,
  parse: state.auth.parse
});

const mapDispatchToProps = dispatch => ({
  setIsOpen: () => dispatch(setIsOpen(false))
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);